import { sendingStatus, Status } from "@/interfaces/status";
import { stateStatus } from "@/interfaces/status";
import { appSettings } from "@/settings";
import { responseStatus } from "@/interfaces/status";
import axios from "axios";

const status: Status = {
  namespaced: true,
  state: {
    url: "https://api.clickup.com",
    tasks: [],
    loadingInformation: false,
    sendStatus: { send: false, type: "" }
  },
  mutations: {
    setSend(state: stateStatus, send: sendingStatus) {
      state.sendStatus = send;
    },
    setStatus(state: stateStatus, data: []) {
      state.tasks = data;
    },
    clearStatus(state: stateStatus) {
      state.tasks = [];
    },
    setLoading(state: stateStatus, loading: boolean) {
      state.loadingInformation = loading;
    }
  },
  actions: {
    async getProjects({ commit, state }) {
      commit("setLoading", true);
      const config = {
        headers: {
          Authorization: appSettings.apiToken
        }
      };
      let arrayTask: responseStatus[] = [];
      let idea: responseStatus[] = [];
      let implementation: responseStatus[] = [];

      await axios
        .get(
          `${appSettings.corsProxyUrl}${state.url}/api/v2/list/${appSettings.implementationId}/task?archived=false`,
          config
        )
        .then(r => (idea = r.data.tasks));

      await axios
        .get(
          `${appSettings.corsProxyUrl}${state.url}/api/v2/list/${appSettings.ideationId}/task?/task?archived=false`,
          config
        )
        .then(r => (implementation = r.data.tasks));

      arrayTask = idea;
      arrayTask.push(...implementation);
      commit("setStatus", arrayTask);
    },
    async postVote({ commit, state }, task: {}) {
      const config = {
        headers: {
          Authorization: appSettings.apiToken,
          "Content-Type": "application/json"
        }
      };

      const clickUpTask = JSON.parse(JSON.stringify(task));

      await axios.post(
        `${appSettings.corsProxyUrl}${state.url}/api/v2/task/${clickUpTask.id}/field/${clickUpTask.custom_fields[0].id}`,
        { value: clickUpTask.custom_fields[0].value },
        config
      );
      commit("setSend", {
        send: true,
        type: "vote"
      });
    },
    async postTask({ commit, state }, task: {}) {
      const config = {
        headers: {
          Authorization: appSettings.apiToken,
          "Content-Type": "application/json"
        }
      };

      await axios.post(
        `${appSettings.corsProxyUrl}${state.url}/api/v2/list/${appSettings.ideationId}/task`,
        task,
        config
      );
      commit("setSend", {
        send: true,
        type: "task"
      });
    },
    async sendMessage({ commit, state }, message: {}) {
      const config = {
        headers: {
          Authorization: appSettings.apiToken,
          "Content-Type": "application/json"
        }
      };

      await axios.post(
        `${appSettings.corsProxyUrl}${state.url}/api/v2/list/${appSettings.messageId}/task`,
        message,
        config
      );
      commit("setSend", {
        send: true,
        type: "message"
      });
    }
  }
};

export default status;
